import React, { useState } from 'react';
import { mapDivEnterToClick, setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
export enum AssessAirwayActions {
	LiftChinToCeiling,
	PutChinToChest,
	StickOutTongue,
	ShowTeeth,
	ExamineNeck,
	RemoveDentures,
	Done,
	None,
}

var selectedIndx = -1;

const AssessAirwayUI = (props: UIProperties<AssessAirwayUIConfig>) => {
	const [currentData, setCurrentData] = useState(null as AssessAirwayActionData);
	const actions = [
		{
			title: 'Lift chin to ceiling',
			type: AssessAirwayActions.LiftChinToCeiling,
			onClick: (data: AssessAirwayActionData) => {
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		}, 
		{
			title: 'Put chin to chest',
			type: AssessAirwayActions.PutChinToChest,
			onClick: (data: AssessAirwayActionData) => {
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		},
		{
			title: 'Open mouth wide and stick out your tongue.',
			type: AssessAirwayActions.StickOutTongue,
			onClick: (data: AssessAirwayActionData) => { 
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		},
		{
			title: 'Are those all your real teeth?',
			type: AssessAirwayActions.ShowTeeth,
			onClick: (data: AssessAirwayActionData) => { 
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		},
		{
			title: 'Can I examine your neck?',
			type: AssessAirwayActions.ExamineNeck,
			onClick: (data: AssessAirwayActionData) => { 
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		},
		{
			title: 'Remove Dentures',
			type: AssessAirwayActions.RemoveDentures,
			onClick: (data: AssessAirwayActionData) => { 
				if(props.parameters.onActionClicked(data)) {
					setCurrentData(data);
					return true;
				}
				return false;
			}
		},
		{
			title: 'Done with Assessment',
			type: AssessAirwayActions.Done,
			onClick: (data: AssessAirwayActionData) => { 
				props.parameters.onActionClicked({relatedAction: AssessAirwayActions.Done,text: '', title: ''})
				return true;
			}
		}
	];

	const displayCurrentTitle = () => {
		// var filtered = props.parameters.data.filter(d => d.relatedAction === currentData.relatedAction);
		// return filtered && filtered.length > 0 ? filtered[0].title : "";
		return currentData.title;
	}

	const displayCurrentText = () => {
		// var filtered = props.parameters.data.filter(d => d.relatedAction === currentData.relatedAction);
		// return filtered && filtered.length > 0 ? filtered[0].text : "";
		return currentData.text;
	}

	const getCurrentData = (action: AssessAirwayActions) => {
		var filtered = props.parameters.data.filter(d => d.relatedAction === action);
		return filtered && filtered.length > 0 ? filtered[0] : null;
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'all'
		}}>
			<div style={{
				position: 'absolute',
				top: '42px',
				right: '220px',
				width: '450px',
				height: '660px',
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)',
				pointerEvents: 'all'
			}}>
				<div style={{
					width: '351px',
					position: 'absolute',
					left: '50px'
				}}>
					{actions.map((action: any, index: number) => {
						const getId = () => {
							if(index === 0) {
								return 'assess-patient-root'
							} else if(index === actions.length - 1) {
								return 'assess-patient-done'
							}

							return 'action-'+index;
						}
						return (
							<div style={{
								
							}} onKeyUp={mapDivEnterToClick} onClick={() => {
								var d = getCurrentData(action.type);
								var a = action.onClick(d);
								selectedIndx = index;
								if(a) {
									if(d && d.onClick) {
										d.onClick();
									}

									setTimeout(() => {
										setFocus('select-me');
										setTimeout(() => {
											setFocus(getId());
										}, 250);
									}, 250);
								}
							}}>
								<p style={{
									fontSize: '24pt',
									textAlign: 'left',
									pointerEvents: 'none'
								}} className='title-font' tabIndex={0} id={getId()}>{action.title}</p>
							</div>
							
						);
					})}
				</div>
			</div>

			{currentData && currentData.imgUrl ? 
				(<div style={{
					position: 'absolute',
					top: '100px',
					left: '200px',
					width: '1040px',
					height: '910px'
				}}>
					<div style={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						maxWidth: '400px',
						transform: 'translate(-50%, -50%)',
						border: '3px solid rgb(192, 161, 6)',
						backgroundColor: 'rgb(36, 36, 36)',
						paddingLeft: '10px',
						paddingRight: '10px',
						paddingTop: '20px',
						paddingBottom: '20px'
					}}>
						<div style={{
							position: 'relative',
							top: '0',
							left: '50%',
							width: '90%',
							transform: 'translate(-50%, 0)'
						}}>
							<img src={currentData.imgUrl} />
						</div>
						
					</div>
					
				</div>) : (null)}

			{currentData ? 
				(<div style={{
					position: 'absolute',
					top: '700px',
					right: '220px',
					width: '450px',
					height: '309px'
				}}>
					<img style={{
						width: '100%',
						height: '70px'
					}} src="./assets/images/SBAR/header_modal_1.png"/>
					<div style={{
						position: 'absolute',
						top: '0',
						left: '0',
						width: '100%',
						height: '70px'
					}}>
						<p style={{
							margin: '0px',
							fontSize: '25pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font" >{displayCurrentTitle()}</p>
					</div>
					<div style={{
						position: 'absolute',
						top: '70px',
						left: '0px',
						width: '100%',
						height: '238px',
						border: '3px solid rgb(192, 161, 6)',
						backgroundColor: 'rgb(36, 36, 36)',
					}}>
						<div style={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							width: '422px',
							height: '65px',
							transform: 'translate(-50%, -50%)'
						}}>
							<p style={{
								margin: '0px',
								fontSize: '18pt',
								textAlign: 'center',
								position: 'relative',
								top: '-70px'
							}} className="title-font" tabIndex={0} id='select-me'  dangerouslySetInnerHTML={{__html: displayCurrentText()}}></p>
						</div>
						
					</div>
					
				</div>) : (null)}
		</div>
	);
};

export interface AssessAirwayUIConfig extends BaseConfig{
	onActionClicked: (data: AssessAirwayActionData) => boolean;
	data: AssessAirwayActionData[];
}

export interface AssessAirwayActionData {
	relatedAction: AssessAirwayActions;
	title: string;
	text: string;
	imgUrl?: string;
	noPoints?: boolean;
	onClick?: () => void;
}

export default AssessAirwayUI;